import React from 'react';

import {
    Grid,
    Typography,
    makeStyles,
    Hidden,
    Breadcrumbs,
    Link,
    Container,
    Paper,
    Divider,
} from '@material-ui/core';
import styles from './styles'



const useStyles = makeStyles(styles);

const SendCopyToEmail = () => {
    const classes = useStyles();


    return (
        <div className={classes.mainContainer} >
            <Container>
                <Grid container justifyContent="flex-start" alignItems='center'>
                    <Grid item className={classes.breadCrumbs}>
                        <Breadcrumbs aria-label='breadcrumb'>
                            <Link color='inherit' href='/'>
                                Bear Hands Pro
                            </Link>
                            <Link color='inherit' href='/tutorials'>
                                tutorials
                            </Link>
                            <Typography color='textPrimary'>Send Copy to Email</Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
                <Paper className={classes.paper}>
                    <Grid item container justifyContent="center" alignItems='center' xs={12}>
                        <Grid item xs={12} className={classes.titleBar}><Typography align='center' style={{ color: 'white' }} variant='h1'>Email out a copy of the report</Typography></Grid>
                        <Grid item lg={10}>
                            <Typography align='center' className={classes.intro} variant="h4">Email a copy of the report to any email, at any time</Typography>
                        </Grid>
                    </Grid>
                    <Grid item container className={classes.pictureHolder} justifyContent="center" alignItems='center' xs={12}>
                        <Hidden mdDown>
                            <Grid item container justifyContent="center" lg={7}>

                                <iframe width="560" height="315" src="https://www.youtube.com/embed/UJ8nw7cQ3Ks" title="Send copy to Email" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Grid>
                        </Hidden>
                        <Hidden lgUp>
                            <Grid item container justifyContent="center" lg={7}>
                                <iframe width="90%" height="250" src="https://www.youtube.com/embed/UJ8nw7cQ3Ks" title="Send copy to Email" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Grid>
                        </Hidden>
                    </Grid>
                    <Grid item container justifyContent='center' alignItems='center'>
                        <Grid item xs={10} className={classes.stepHeading}>
                            <Typography variant='h2'>
                                You can send a copy of the report to any email, at any time!
                            </Typography>
                            <Divider className={classes.stepHeadingDivider} variant="middle" />
                        </Grid>
                        <Grid item lg={5} className={classes.stepText}>
                            <Typography variant='h6'>
                                To send a copy you find it in the menu on the right.
                            </Typography>
                        </Grid>
                        <Grid item lg={5} className={classes.stepPicture} xs={12}>
                            <img alt='Add clients by filling out form on left.' src='/static/tutorials/sendCopytoEmail/sendCopytoEmailMenu.png' width='100%' />

                        </Grid>
                        <Grid xs={12}>
                            <Divider className={classes.stepHeadingDivider} variant="middle" />
                        </Grid>
                        <Grid item lg={5} className={classes.stepText}>
                            <Typography variant='h6'>
                                Enter the email in the pop up box!
                            </Typography>
                        </Grid>
                        <Grid item lg={5} className={classes.stepPicture} xs={12}>
                            <img alt='Add CLients by csv' src='/static/tutorials/sendCopytoEmail/sendCopytoEmail.png' width='100%' />
                        </Grid>
                        <Grid xs={12}>
                            <Divider className={classes.stepHeadingDivider} variant="middle" />
                        </Grid>
                        <Grid item lg={5} className={classes.stepText}>
                            <Typography variant='h6'>
                                It can take a few minutes, but if it works you should be seeing.
                            </Typography>
                        </Grid>
                        <Grid item lg={5} className={classes.stepPicture} xs={12}>
                            <img alt='Add CLients by csv' src='/static/tutorials/sendCopytoEmail/sendCopytoEmailSuccess.png' width='100%' />
                        </Grid>
                        <Grid xs={12}>
                            <Divider className={classes.stepHeadingDivider} variant="middle" />
                        </Grid>
                    </Grid>
                    <Divider />
                </Paper>
            </Container>
        </div >
    )
}

export default SendCopyToEmail;